import {
  REWARD_PROMPT_COOLDOWN_MS,
  getQuestRewardPromptSignature,
} from "./questRewards";

export function areQuestRewardPromptSourcesReady({
  currentUid,
  profile,
  loadingProfile,
  friendsInitialized,
}) {
  return Boolean(
    currentUid &&
      profile &&
      loadingProfile === false &&
      friendsInitialized === true
  );
}

export function createQuestRewardPromptGuard(rewards = [], shownAtMs = Date.now()) {
  return {
    shownAtMs,
    signature: getQuestRewardPromptSignature(rewards),
    rewardIds: rewards.map((reward) => reward.claimId || reward.id).filter(Boolean),
  };
}

export function isQuestRewardPromptBlockedByLocalGuard({
  guard,
  nowMs = Date.now(),
}) {
  if (!guard?.shownAtMs) return false;
  if (nowMs - guard.shownAtMs >= REWARD_PROMPT_COOLDOWN_MS) return false;
  return true;
}

export function getQuestRewardPromptDisplay(rewards = [], visibleLimit = 3) {
  const safeLimit = Math.max(0, Number(visibleLimit) || 0);
  return {
    visibleRewards: rewards.slice(0, safeLimit),
    remainingCount: Math.max(0, rewards.length - safeLimit),
  };
}

export function getQuestRewardPromptName(reward = {}, t) {
  const key = reward?.labelKey ? `rewards.items.${reward.labelKey}` : "";
  const translated = key && typeof t === "function" ? t(key) : "";

  if (translated && typeof translated === "object") {
    return translated.name || translated.description || reward.labelKey || reward.id || "";
  }

  if (typeof translated === "string" && translated && translated !== key) {
    return translated;
  }

  if (reward?.labelKey && typeof t === "function") {
    const nameKey = `rewards.items.${reward.labelKey}.name`;
    const nestedName = t(nameKey);
    if (typeof nestedName === "string" && nestedName && nestedName !== nameKey) {
      return nestedName;
    }
  }

  return reward?.labelKey || reward?.id || "";
}
